import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { TotalBar as UITotalBar } from '@mews-distributor/ui';

import { getCurrencyCode } from '../../../modules/app/selectors';
import {
    getMerchantCurrencyCodeOrEnterpriseDefaultCurrencyCode,
    shouldShowPropertyCurrency,
} from '../../../modules/entities/reservations/selectors';
import {
    getFormattedSurchargeFees,
    getSelectedEnterprisePaymentGatewayDefaultCurrencyCode,
    hasSelectedEnterpriseSurcharge,
} from '../../../modules/paymentConfigurations/selectors';
import { hasSelectedEnterpriseNetPricing } from '../../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ApplicationState } from '../../../types';
import {
    getReservationsGrossTotalInPropertyCurrency,
    getReservationsSimpleTotalAmount,
} from '../../../views/checkout/data/viewSelectors';
import { OrderRateGroupDescription } from './OrderRateGroupDescription';

const renderOrderRateGroupDescription = () => <OrderRateGroupDescription />;

export const TotalBar = connect<$TSFixMe, {}, $TSFixMe, ApplicationState>(
    createStructuredSelector({
        totalPrice: getReservationsSimpleTotalAmount,
        totalPriceInPropertyCurrency: getReservationsGrossTotalInPropertyCurrency,
        showPropertyCurrency: shouldShowPropertyCurrency,
        hasNetPricing: hasSelectedEnterpriseNetPricing,
        hasSurchargeService: hasSelectedEnterpriseSurcharge,
        surchargeFees: getFormattedSurchargeFees,
        renderRateGroupDescription: (state, { showRateGroupDescription }) =>
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            showRateGroupDescription ? renderOrderRateGroupDescription : null,
        selectedCurrency: getCurrencyCode,
        paymentGatewayCurrency: getSelectedEnterprisePaymentGatewayDefaultCurrencyCode,
        hotelCurrency: getMerchantCurrencyCodeOrEnterpriseDefaultCurrencyCode,
    })
)(UITotalBar);
